'use es6';

import { createContext } from 'react';
export const SidePanelContext = /*#__PURE__*/createContext();